import React, { useState } from 'react'
import { useGetClients } from '~pages/Simulators/hooks/useSimulatorsQuery';
import { object, string } from "yup";
import * as yup from "yup";

const useModalSimulators = () => {
  const [isModalOpenSimulators, setModalOpenSimulators] = useState(false);

  const openModalSimulators = () => {
    setModalOpenSimulators(true);
  };

  const closeModalSimulators = () => {
    setModalOpenSimulators(false);
  };

  const clients = useGetClients();
  const filteredCustomers = clients.data ? clients.data.map(cliente => {
    return { label: `${cliente.idCliente} - ${cliente.razaoSocial}`, id: cliente.idCliente };
  }) : [];

  const validation = object({
    simulador: yup.number(),
  });

  const [initial, setinitial] = useState({
    simulador: 0,
  });

  return {
    isModalOpenSimulators,
    setModalOpenSimulators,
    closeModalSimulators,
    openModalSimulators,
    filteredCustomers,
    validation,
    initial,
    setinitial


  }
}


export default useModalSimulators